import { graphql } from 'react-apollo'

import { ApplicationError, NotFoundError } from '../../helpers/errors'
import { nationalExperiencePageToNavLink } from '../../helpers/national-experience-page-to-nav-link'

import query from './query.graphql'

export { query }

export const mapPropsToOptions = () => ({
  variables: {},
  errorPolicy: 'ignore',
  context: { version: 2 },
})

export const mapDataToProps = ({ data }) => {
  const { loading, error, cfNationalExperiencePageCollection } = data

  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (
    !cfNationalExperiencePageCollection ||
    !cfNationalExperiencePageCollection.items
  ) {
    return {
      error: new NotFoundError(),
    }
  }

  return {
    nationalExperienceNavLinks: cfNationalExperiencePageCollection.items.map(
      nationalExperiencePageToNavLink
    ),
  }
}

const withNationalExperienceNavLinks = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withNationalExperienceNavLinks
